import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuickIndex from './components/QuickIndex';
import RoundupSection from './components/RoundupSection';
import TimelineSection from './components/TimelineSection';
import CompareSection from './components/CompareSection';
import OpinionSection from './components/OpinionSection';
import GlossarySection from './components/GlossarySection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <main className="min-h-screen bg-cream text-ink">
      <Navbar />
      <Hero />
      <QuickIndex />
      <RoundupSection />
      <TimelineSection />
      <CompareSection />
      <OpinionSection />
      <GlossarySection />
      <FaqSection />
      <SiteFooter />
    </main>
  );
}